/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { IPaginationBaseState, Pageable } from "@advapacs/common";

export interface CustomerPACSSearch extends IPaginationBaseState {
  searchKeyword?: string;
  page: number;
  status?: string;
  category?: string;
}

export interface ICustomerPACS {
  id?: string;
  name: string;
  logoUrl: string;
  description: string;
  status: string;
  mfaRequired: boolean;
  brands?: IBrandPACS[];
  brand?: IBrandPACS;
}

export const defaultValue: Readonly<ICustomerPACS> = {
  name: "",
  logoUrl: "",
  description: "",
  status: undefined,
  mfaRequired: false,
  brands: [],
};

export const initSearchState: CustomerPACSSearch = {
  pageSize: 10,
  page: 0,
  sort: "",
  order: "",
  searchKeyword: "",
  status: undefined,
};

export interface IBrandPACS {
  id?: string;
  enabled: boolean;
  name: string;
  description: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  category: string;
  logoUrl: string;
  services: Array<string>;
}

export interface IBrandPACDetail {
  id?: string;
  logoUrl: string;
  name: string;
  description: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  category: string;
  services: Array<string>;
  clinicianPortalId: string;
  mfaRequired: boolean;
}

export interface CounterPACS {
  all: number;
  acceptedCount: number;
  pendingCount: number;
  declinedCount: number;
  revokedCount: number;
  totalCount: number;
}

export const initCounterPACS: CounterPACS = {
  all: 0,
  acceptedCount: 0,
  pendingCount: 0,
  declinedCount: 0,
  revokedCount: 0,
  totalCount: 0,
};

export interface PaginationPacsResponse<T> {
  content: T[];
  pageable: Pageable;
  count?: CounterPACS;
}
